import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleProcess from '../../components/Process/SingleProcess';

const Process = () => {
    const [processes, setProcesses] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch processes from the API
    useEffect(() => {
        axios.get('https://yautiktechnology.com/api/process')
            .then((response) => {
                setProcesses(response.data); // Set processes state with API data
                setLoading(false); // Set loading to false once data is fetched
            })
            .catch((error) => {
                console.error('Error fetching process data:', error);
                setLoading(false); // Set loading to false in case of an error
            });
    }, []);

    return (
        <div className="rs-process style2 pt-120 pb-112 md-pt-80 md-pb-72">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-46"
                    subtitleClass="sub-text style-bg"
                    subtitle="Process"
                    titleClass="title title2"
                    title="Our Working Process"
                />
                <div className="row">
                    {loading ? (
                        <p>Loading...</p>  // Show loading message while fetching data
                    ) : (
                        processes.map((process) => (
                            <div className="col-lg-3 col-sm-6 md-mb-50" key={process.id}>
                                <SingleProcess
                                    itemClass="addon-process"
                                    processImage={process.imageUrl}  // Dynamically set imageUrl
                                    titleClass="title"
                                    Title={process.description}  // Dynamically set description
                                />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default Process;
